import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n';
import en from './lang/en.json'
import fr from './lang/fr.json'
import routes from './routes/routes'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBlenderPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VueMeta from 'vue-meta'

library.add(faBlenderPhone)

Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

export const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages: {en, fr},
  silentTranslationWarn: true
});

// configure router
export const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  }
})


new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')
